exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Online {\n  top: 22px;\n  z-index: 9;\n  right: 265px;\n  float: right;\n  position: fixed;\n  float: right;\n  color: #53a75c; }\n\n.Offline {\n  top: 22px;\n  z-index: 9;\n  right: 265px;\n  float: right;\n  position: fixed;\n  float: right;\n  color: #e75639; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src898022850/src/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main